




















import { mapGetters } from 'vuex';
import BscScanIcon from '@/assets/images/icons/bscscan-icon.svg?inline';
import { copyToClipBoard } from '@/helpers/copyToClipBoard';

export default {
  components: {
    BscScanIcon
  },

  computed: {
    ...mapGetters('TokensInfo', ['smartContractAddressBSC'])
  },

  methods: {
    copyToClipBoard
  }
};
